import Container from '~/components/container/Container';
import NoContent from '~/components/noContent/NoConTent';

function AlbumAll() {
    return (
        <Container>
            <NoContent />
        </Container>
    );
}

export default AlbumAll;
